import { render, staticRenderFns } from "./HypotekyItemsWrapper.vue?vue&type=template&id=356ea81c&scoped=true&"
import script from "./HypotekyItemsWrapper.vue?vue&type=script&lang=js&"
export * from "./HypotekyItemsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HypotekyItemsWrapper.vue?vue&type=style&index=0&id=356ea81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ea81c",
  null
  
)

export default component.exports